import { Maybe, Organisation } from '@acre/graphql'

export const logoFromOrgLogo = (organisation: Maybe<Organisation>): string | null | undefined => {
  if (organisation) {
    const companyLogo = organisation?.logo
    const logo = companyLogo ? companyLogo : null
    return logo
  }
}
